module.exports = __webpack_public_path__ + "img/E7632F_FBA06B_BB2905_FB865E-256px.4a1f7c06.png";